import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./News.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import vsImage from "../../assets/images/vs.png";
import Timer from "../Timer/Timer";
import { useDispatch, useSelector } from "react-redux";
import { homeData } from "../../features/home/homeSlice";
import { newsData } from "../../features/news/newSlice";
import { Link } from "react-router-dom";
import Skeleton from "../Skeleton/Skeleton";


const News = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.news.data);
  const pending = useSelector((state) => state.news.pending);
  const error = useSelector((state) => state.news.error)
  const finalData = data.data
  

  var settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    swipeToSlide: true,
    rows: 2,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows : 1,
        }
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows : 1,
        }
      }
    ]
  };

  useEffect( () => {
    // AOS.init({ duration: 2000 });

    
      dispatch(newsData())
    
    
  }, [dispatch]);

  if (pending) {
    return (<div className={styles.loader}>
      <Skeleton type= "news" />
    </div>);;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className={styles.parentContainer} id="newsSlider">
      <div className={styles.fixturesHeading}>
        <h3>LATEST NEWS</h3>
      </div>
      <div className={styles.mainContainer} >
      
      <Slider {...settings} className={styles.mainSliderContainer}>
        {finalData && finalData.map((item, index) => (
          <Link to={`/news/${item.news_id}`}>
          <div className={styles.slide} key={index}>
            <div className={styles.newsData}>
              <div className={styles.firstContainer}>
                <img src={`https://images.weserv.nl/?url=${item.image}` }alt=""  className={styles.newsImage}/>
              </div>
              <div className={styles.secondContainer}>
                <p className={styles.newsDate}>{item.pub_date}</p>
              </div>
              <div className={styles.thirdContainer}>
                <p>{item.title}</p>
              </div>
            </div>
          </div>
          </Link>
        ))}
      </Slider>
      <div className={styles.allFixturesButton}>
      {/* <Link to='/siteMaintenance'> */}
          {/* <button>VIEW ALL</button> */}
          {/* </Link> */}
       
    </div>
      </div>
      
    </div>
    
  );
};

export default News;
